import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';

const Screen = lazy(() =>
  import('../screens/Roles/RolesScreen').then(m => ({ default: m.RolesScreen })),
);

export const Route = createFileRoute('/roles')({
  component: () => (
    <Suspense fallback={<div style={{ padding: 32, color: 'var(--lca-gray-500)', fontSize: 13 }}>Loading…</div>}>
      <Screen />
    </Suspense>
  ),
});
